export const ERROR_MESSAGES = {
  UNEXPECTED_ERROR: '予期せぬエラーが発生しました。システム管理者に連絡してください。',
  NETWORK_ERROR: 'ネットワークエラーが発生しました。ネットワーク接続を確認してください。',
};

export const STATUS_MESSAGES = {
  LOADING_DATA: 'データ読み込み中',
  NO_DATA: 'データがありません',
};
